export const InboxItemType_Order = 'inbox-order';
export const InboxItemType_Wizard = 'inbox-wizard';
export const InboxItemType_DataNeeded = 'inbox-data-needed';
// for type
export const _inboxItem_Types = [InboxItemType_Order, InboxItemType_Wizard, InboxItemType_DataNeeded];
//# sourceMappingURL=consts.js.map